/**
 * Returns current timezone offset with january and june diff
 */
export function getCurrentTimezoneOffset(): string {
  // check for DST (Daylight saving time)
  const januaryOffset = -1 * new Date(2010, 0, 2).getTimezoneOffset();
  const juneOffset = -1 * new Date(2010, 5, 2).getTimezoneOffset();
  const diff = januaryOffset - juneOffset;

  let timezoneOffsetValue = (-1 * new Date().getTimezoneOffset()).toString();

  if (diff !== 0) {
    timezoneOffsetValue += ',1';
  } else {
    timezoneOffsetValue += ',0';
  }

  return timezoneOffsetValue;
}
